import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=626ecff4&"
import script from "./AddToCart.vue?vue&type=script&lang=js&"
export * from "./AddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,OpusQuantitySelector: require('/~/src/modules/opus/components/QuantitySelector.vue').default,SubscribeOutOfStock: require('/~/src/modules/opus-ecom/components/SubscribeOutOfStock.vue').default,OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default,WishlistButton: require('/~/src/modules/opus-ecom/components/Catalog/WishlistButton.vue').default})
